import {
  CUSTOM_FIELD_FETCH_REQUEST,
  CUSTOM_FIELD_FETCH_REQUEST_SUCCESS,
  CUSTOM_FIELD_FETCH_REQUEST_FAILURE,
  CUSTOM_FIELD_CLEAN_REQUEST,
} from './actionTypes';

export const customFieldFetchRequest = () => {
  return {
    type: CUSTOM_FIELD_FETCH_REQUEST,
  };
};

export const customFieldFetchRequestSuccess = (data) => {
  return {
    type: CUSTOM_FIELD_FETCH_REQUEST_SUCCESS,
    data,
  };
};

export const customFieldFetchRequestFailure = (error) => {
  return {
    type: CUSTOM_FIELD_FETCH_REQUEST_FAILURE,
    error,
  };
};

export const customFieldCleanRequest = () => {
  return {
    type: CUSTOM_FIELD_CLEAN_REQUEST,
  };
};
